module.exports = __webpack_public_path__ + "static/media/splash.0eac0d0b.jpg";